export default __webpack_public_path__ + "static/media/search.42d25e0c.svg";